/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgImageCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="currentColor" rx={20} />
    <path fill="#fff" d="M25.958 16.75a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25Z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M9.167 11.333c0-1.196.97-2.166 2.166-2.166h17.334c1.196 0 2.166.97 2.166 2.166v17.334c0 1.196-.97 2.166-2.166 2.166H11.333a2.167 2.167 0 0 1-2.166-2.166V11.333Zm2.166-.541h17.334a.54.54 0 0 1 .541.541v11.851l-3.217-3.217a.812.812 0 0 0-1.149 0l-2.675 2.676-5.926-5.926a.813.813 0 0 0-1.149 0l-4.3 4.3v-9.684a.54.54 0 0 1 .541-.541Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgImageCircle)
export default Memo
